function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.6665 14.6666V2.66665C2.6665 2.56315 2.6906 2.46107 2.73689 2.3685C2.78317 2.27593 2.85037 2.19541 2.93317 2.13331C3.62556 1.61402 4.46769 1.33331 5.33317 1.33331C7.33317 1.33331 8.6665 2.66665 10.2218 2.66665C11.1107 2.66665 11.7923 2.48887 12.2665 2.13331C12.3656 2.05903 12.4833 2.01379 12.6066 2.00267C12.7299 1.99155 12.8539 2.01499 12.9646 2.07036C13.0754 2.12573 13.1685 2.21084 13.2336 2.31616C13.2987 2.42148 13.3332 2.54284 13.3332 2.66665V9.33331C13.3332 9.43681 13.3091 9.53889 13.2628 9.63146C13.2165 9.72403 13.1493 9.80455 13.0665 9.86665C12.3741 10.3859 11.532 10.6666 10.6665 10.6666C8.6665 10.6666 7.33317 9.33331 5.33317 9.33331C4.34925 9.33334 3.39985 9.69601 2.6665 10.352",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.4e075f0e.svg";
export { ForwardRef as ReactComponent };